import React from 'react';
import { Icon, Typography } from '@drone-js/core';

const RouteItemHeader: React.FC<{ heading?: string }> = (props) => {
    return (
        <span data-testid="route-item-header">
            <Icon id="fill.transportation.bus" size="14" color="product.primary" />
            <Typography tag="span" variant="body-s" mx="4" textColor="deprecated.secondary.interactive">
                {props.heading}
            </Typography>
        </span>
    );
};
RouteItemHeader.displayName = 'RouteItemHeader';

export default RouteItemHeader;
